import { clone, EModalType, ISharedJourney } from '../../helpers/';
import types from '../types';

export interface ISharedJourneyConfigState {
    SharedJourney: ISharedJourney;
    previousOutputBlocks: any;

}

export const initialState: ISharedJourneyConfigState = {

    SharedJourney: {
        ComponentId: '',
        Properties: [],
        OutputValues: null
    },
    previousOutputBlocks: {}

};

const sharedJourneyConfigReducer = function (state: ISharedJourneyConfigState = initialState, action): ISharedJourneyConfigState {

    let stateClone: ISharedJourneyConfigState = clone(state);

    switch (action.type) {

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.sharedJourney, action.previousOutputBlocks);
            break;

        case types.SET_SHARED_JOURNEY_CONFIG:
            stateClone = setSharedJourneyConfig(stateClone, action.sharedJourney);
            break;

        case types.UPDATE_SHARED_JOURNEY_OUTPUT:
            stateClone = updateOutput(stateClone, action.index, action.name);
            break;

    }

    return stateClone;

};

let toggleDialog = (state: ISharedJourneyConfigState, openModal: EModalType, sharedJourney: ISharedJourney, previousOutputBlocks: any): ISharedJourneyConfigState => {

    if (openModal === EModalType.SharedJourneyConfig) {

        state.SharedJourney = sharedJourney;
        state.previousOutputBlocks = previousOutputBlocks || {};

    }

    return state;

};

let setSharedJourneyConfig = (state: ISharedJourneyConfigState, sharedJourney: ISharedJourney) => {

    state.SharedJourney = sharedJourney;

    return state;

};

let updateOutput = (state: ISharedJourneyConfigState, outputIndex: number, name: string): ISharedJourneyConfigState => {
    state.SharedJourney.OutputValues[outputIndex].LogicalName = name;
    return state;
}

export default sharedJourneyConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/shared-journey-config.ts